/* eslint-disable no-use-before-define */
import Toggle from 'components/Elements/Toggle/Toggle';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SettingsJira = (props) => {
  const { bot, updateJiraSettings, user } = props;
  const { i18n } = useTranslation();

  const [JiraSettings, setJiraSettings] = useState({
    nameSpace: '',
    requestTypeDefault: '',
    projectIdDefault: '',
    statusIdDefault: '',
    email: '',
    tokenAPI: '',
    validateLogin: false,
  });

  useEffect(() => {
    if (bot && bot.settings && bot.settings.jiraSettings) {
      setJiraSettings(bot.settings.jiraSettings);
    }
  }, [bot]);

  const changeSettings = (name, value) => {
    const updatedSettings = { ...JiraSettings, [name]: value };
    setJiraSettings(updatedSettings);
  };

  const handleSwitch = () => {
    const isSelect = !JiraSettings.validateLogin;
    const updatedSettings = { ...JiraSettings, validateLogin: isSelect };

    console.log('updatedSettings', updatedSettings);
    setJiraSettings(updatedSettings);
  };

  const updateBot = () => {
    if (bot) {
      const data = JiraSettings;
      updateJiraSettings(bot._id, data);
    }
  };

  return (
    <div>
      <div className="form-group">
        <div>
          <div className="title">
            {i18n.t('Configurar Integrações ')}
            <strong>{i18n.t('Jira')}</strong>
          </div>
          <div className="subtitle mt-2">
            {i18n.t(
              'Insira os campos name space, usuário e API Token de sua conta Jira'
            )}
          </div>
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('Name space')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="nameSpace"
            className="form-control"
            placeholder="{name-space}.atlassian.net"
            value={JiraSettings.nameSpace || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('Email')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="email"
            className="form-control"
            placeholder="email"
            value={JiraSettings.email || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('tokenAPI')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="tokenAPI"
            className="form-control"
            placeholder="tokenAPI"
            value={JiraSettings.tokenAPI || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('ID do projeto padrão')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="projectIdDefault"
            className="form-control"
            placeholder="ID Projeto"
            value={JiraSettings.projectIdDefault || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('Tipo de ticket padrão')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="requestTypeDefault"
            className="form-control"
            placeholder="ID Tipo ticket"
            value={JiraSettings.requestTypeDefault || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('Status padrão de fechamento de ticket')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="statusIdDefault"
            className="form-control"
            placeholder="ID Status"
            value={JiraSettings.statusIdDefault || ''}
            onChange={(e) => changeSettings(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <div className="settings-toogle-jira">
            <Toggle
              name="validateLogin"
              disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
              checked={JiraSettings.validateLogin || false}
              onChange={() => {
                handleSwitch();
              }}
            />
            <label>
              {i18n.t('Permitir criação de tickets sem conta no Jira')}
            </label>
          </div>
        </div>
      </div>

      <div className="form-group mt-3">
        <button
          disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
          className="btn btn-primary mr-1"
          onClick={updateBot}
        >
          {i18n.t('salvar')}
        </button>
      </div>
    </div>
  );
};

export default SettingsJira;
